import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Configuration } from 'src/app/models/configurations/configuration';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ConfigurationDetailsComponent } from '../../configuration-details/configuration-details.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationApplicationStatus } from 'src/app/models/configurations/configuration-state';
import { Instance } from 'src/app/models/instance/instance';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Router } from '@angular/router';
import { EnvironmentPaginatorComponent } from 'src/app/main/environment-details/environment-paginator/environment-paginator.component';
import { translate } from '@jsverse/transloco';
import { EnvironmentTableComponent } from 'src/app/main/environment-details/environment-table/environment-table.component';
import { AvailabilityStatus } from 'src/app/models/availability-status';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-instance-apply-configuration',
    templateUrl: './instance-apply-configuration.component.html',
    styleUrls: ['./instance-apply-configuration.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class InstanceApplyConfigurationComponent  implements OnInit {
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @ViewChild(EnvironmentPaginatorComponent)paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
private destroyRef = inject(DestroyRef);
  @Output() applyConfigClick = new EventEmitter();

  @Input() instance: Instance;

  @Input() isVerifying: boolean;

  @Input() configs: any[];
  @Input() oldView: boolean;
  @Input() configLoaded: boolean;
  ConfigurationApplicationStatus = ConfigurationApplicationStatus;

  configurations: any[];
  pageConfigurations: Configuration[];
  filteredConfigurations: Configuration[];
  expandedRows: KeyValueMap<string, boolean> = {};

  selection: Configuration;
  Constants = Constants;
  deploymentClass = DeploymentClass;
  PermissionKeys = PermissionKeys;
  inProgress = false;
  searchValue: string;
  selectedId: any;
  disableSelect = false;
  verifiedToApply = false;
  permissionsMap: { [key: string]: boolean };
  DataZone = DataZone;
  isLoading: boolean;
  count: number;
  permissionRequired: any;
  DeployStatus = DeployStatus;
  clientName: any;
  @Output() refreshClick = new EventEmitter();
  pageIndex = 0;
  paginationSize = 10;
  configData: any;
  searchedResult = [];
  AvailabilityStatus = AvailabilityStatus;
  displayColumns =[
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'name',
      name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.RELEASE_PACKAGE_NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
      keyLink: 'navigation'
    },
    {
      key: 'version',
      name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.VERSION',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'dateGenerated',
      name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DATE_GENERATED',
      type: 'date',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'status',
      name: '',
      type: 'status',
      sortable: false,
      visible: true,
      disable: true,
    },
    {
      key: 'applyConfig',
      name: '',
      type: 'applyConfig',
      sortable: false,
      visible: true,
      disable: false,
    }
  ];
  readonly ACTION_NOT_ALLOWED_STATES = [DeployStatus.STARTING, DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZED, DeployStatus.INITIALIZING];


  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.INPROGRESS];


  constructor(public sidenavService: SidenavService, public datepipe: DatePipe, private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog, private permissionsService: PermissionsService, private crvtService: CRVTService,  private router: Router) {
    
  }

  @Input() set applyConfigInProgressing(applyConfigInProgress) {
    this.inProgress = applyConfigInProgress;
  };

  @Input() set availableConfigurations(availableConfiguration: Configuration[]) {
    this.configurations = availableConfiguration !== undefined ? [...availableConfiguration] : [];
    if (!this.selectedId){
      this.updateSelectedPack();
    }
    const selected = this.configurations.find(item => item.id === this.selectedId);
    this.configurations.sort(this.defaultComparator);
    if (selected) {
      this.configurations = this.configurations.filter(item => item.id !== this.selectedId);
      this.configurations = [selected, ...this.configurations];
      this.setFlagValues(selected);
    } else if (!this.configurations.find(item => item.id === this.selectedId)) {
      this.disableSelect = false;
      this.verifiedToApply = false;
    }
    if (this.instance && this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED) {
      this.disableSelect = true;
    }
    this.inProgress = false;
    this.search(this.searchValue);
    if (!this.oldView) {
      this.modifyConfiguration();
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.clientName = this.router.url.split('.')[0].split('/')[3];
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.permissionRequired = ((this.instance?.dataZone === DataZone.DEVELOPMENT && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII]) || (this.instance?.dataZone === DataZone.SECURE && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII]) || (this.instance?.dataZone === DataZone.LIVE && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE])) ? true : false;
    const selected = this.configurations.find(config => config.id === this.instance?.latestConfigurationState?.configurationId);
    if (selected && selected.skipTest) {
      this.selectedId = selected?.id;
      this.selection = selected;
      this.configurations = this.configurations.filter(item => item.id !== this.selectedId);
      this.configurations = [selected, ...this.configurations];
      this.setFlagValues(this.selection);
    }
    if (this.instance && this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED  && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED) {
        this.disableSelect = true;
      }
      if(this.oldView){
      this.paginator.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      const startIndex = pageEvent.pageIndex * pageEvent.pageSize;
      this.pageConfigurations = this.filteredConfigurations.slice(startIndex, startIndex + pageEvent.pageSize);
      if (!this.pageConfigurations.includes(this.selection)) {
      }
      this.pageConfigurations.filter((item: any) => {
        const patchValue = parseInt(item.manifest.version.split('.').pop(), 10);
        if(patchValue > 0) {
          item.hotfix = true;
        }
      });
      this.changeDetectorRef.detectChanges();
    });
  } else {
    const element = <HTMLElement> document.getElementsByClassName("config-paginator")[0];
    if (element) {
      element.style.display = 'none';
    }
    this.modifyConfiguration();
  }
    this.search();
  }

  setFlagValues(selected): void {
    if ((!selected.status && selected.skipTest) || selected?.status === ConfigurationApplicationStatus.CONFIGURING ||
      selected?.status === ConfigurationApplicationStatus.CONFIGURED ||
      selected?.status === ConfigurationApplicationStatus.TESTING || selected?.status === ConfigurationApplicationStatus.VERIFYING ||
      (this.instance && this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED)) {
        this.disableSelect = true;
    } else if (selected?.status === ConfigurationApplicationStatus.TEST_FAILED) {
      this.disableSelect = false;
      this.verifiedToApply = false;
    } else if(selected?.status === ConfigurationApplicationStatus.VERIFIED) {
      this.disableSelect = false;
      this.isVerifying = false;
      this.verifiedToApply = false;
    };

    if (this.verifiedToApply) {
      this.configurations = this.configurations.filter(item => item.id === this.selectedId);
    }
  }

  expandRow(configuration: Configuration): void {
     this.expandedRows[configuration.id] = !this.expandedRows[configuration.id];
  }

  configurationNameClick(configuration: any): void {
    configuration.instanceName = this.instance.name;
    this.matDialog.open(ConfigurationDetailsComponent, {
      height: '60vh',
      width: '70vw',
      data: {
        configuration
      }
    });
  }

  refreshInstanceForm(): void {
    this.isLoading = true;
    // this.loadData();
    this.refreshClick.emit();
    this.isLoading = false;

    this.count = this.count !== 1 ? 1 : 0;
  if(!this.oldView){
    if (this.paginatorRef) {
      this.paginatorRef.pageIndex = 0;
    }
    this.resetPaginator();
  }
  this.updateSelectedPack();
    // this.defaultState = true;
    // this.defaultState = false;
  }

  /**
   * Performs a simple search in the list of configurations
   *
   * @param value Method that filters displayed configurations based on search criteria.
   */
  search(value?: string): void {
    if(value) {
      this.searchValue = value.trim().toLowerCase();
      this.filteredConfigurations = this.configurations.filter(config => {
        let dateMatch = false;
        if (config.manifest?.dataGenerated) {
          const formatted = new Date(config.manifest?.dataGenerated).toLocaleString('en-GB', {day: '2-digit',month: 'short',year: '2-digit',hour: '2-digit',minute: '2-digit',second: '2-digit',hour12: false,timeZone: 'UTC'}).replace(',', '');
          const dateWithOffset = `${formatted} +0000`.toLowerCase();
          dateMatch = dateWithOffset.includes(this.searchValue);
        }
        return config.manifest.name.toLowerCase().includes(this.searchValue) ||
        config.manifest.version.toLowerCase().includes(this.searchValue) || dateMatch ;
              });
    } else {
      this.searchValue = '';
      this.filteredConfigurations = this.configurations;
    }

    // Clear selection when page is changed
    if (this.selection && !this.filteredConfigurations.includes(this.selection)) {
      // this.selection = null;
    }

    // If there is only one configuration select it by default
    if (this.filteredConfigurations.length === 1) {
      this.selection = this.filteredConfigurations[0];
    }
    if(this.oldView){
    this.paginator.length = this.filteredConfigurations.length;
    }
  }

  /**
   * Changes the selection each time we click on a row
   *
   * @param row - the selected row
   */
  select(row): void {
    this.selection = row;
    this.modifyConfiguration();
  }

  /**
   * Applies the selected configuration
   */
  applyConfiguration(): void {
    this.selectedId = this.selection.id;
    this.isVerifying = false;
    if (this.selection.status === ConfigurationApplicationStatus.VERIFIED) {
      this.verifiedToApply = true;
    }
    const selectedConfiguration = this.selection;
    this.applyConfigClick.emit(selectedConfiguration);
  }

  downloadPackage(configuration, pack?): void {
    if(!this.oldView) {
      pack = configuration.type;
    }
    const filename = pack === 'config-packs' ? configuration?.manifest?.config?.name : pack === 'test-packs' ?
      configuration?.manifest?.test?.name : pack === 'reference-packs' ? configuration?.manifest?.references?.name : configuration?.manifest?.code?.name;
    this.crvtService.downloadReleasePack(pack, configuration.blueprintId, filename, this.clientName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  private defaultComparator(config1: Configuration, config2: Configuration): number {
    if (config1?.manifest?.dataGenerated && config2?.manifest?.dataGenerated) {
      return new Date(config2.manifest.dataGenerated).getTime() - new Date(config1.manifest.dataGenerated).getTime();
    }
    return 0;
  }
  /**
   * Updates local pagination state (page size and index)
   * Delegates the pagination event to the table reference to trigger data reload or view update
   */
  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }
  //Updates local pagination state (page size and index)
  resetPaginator() {
    this.paginationSize = 10;
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }
  //Updates local pagination state (page size and index)
  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }
  /**
   * Prepares normalized row data for the shared table component.
   * Enforces consistent row structure: same keys for all rows,
   * values vary based on selection and state.
  */
  modifyConfiguration() {
    if(!this.permissionsMap) {
      this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    }
    const disableAction = this.ACTION_NOT_ALLOWED_STATES.includes(this.instance?.status);
    const deployStatus = this.INSTANCE_DEPLOYING_STATES.includes(this.instance?.status);
    this.configData = this.configurations?.map(config => {
      const patchValue = parseInt(config?.manifest?.version?.split('.').pop() ?? '0',10);
      let status = '';
      if (this.selection?.id === config?.id) {
        if ( (this.inProgress || (!config.status && config.skipTest)) && !this.isVerifying) {
          status = translate('CONFIGURATIONS.STATE.APPLYING_CONFIGURATION');
        }
        if ( !this.inProgress && config.status && !this.isVerifying && (config.status === ConfigurationApplicationStatus.CONFIGURING ||
            config.status === ConfigurationApplicationStatus.CONFIGURED || config.status === ConfigurationApplicationStatus.TESTING) && config.status !== ConfigurationApplicationStatus.CONFIGURE_FAILED) {
          status = config.status === ConfigurationApplicationStatus.TESTING ? translate('CONFIGURATIONS.STATE.TESTING_UPDATE') : translate('CONFIGURATIONS.STATE.APPLYING_CONFIGURATION');
        }
        if (this.isVerifying && config.status !== ConfigurationApplicationStatus.VERIFIED) {
          status = translate('CONFIGURATIONS.STATE.VERIFY_DEPLOYING');
        }
        if (config.status && (config.status === ConfigurationApplicationStatus.VERIFIED || config.status === ConfigurationApplicationStatus.TEST_FAILED)) {
          status = config.status === ConfigurationApplicationStatus.TEST_FAILED ? translate('CONFIGURATIONS.STATE.UPDATE_FAILED') : config.status;
        }
      }
      config.instance = this.instance;
      return {
        id: config?.id,
        selected: this.selection?.id === config?.id,
        name: config?.manifest?.name,
        version: config?.manifest?.version,
        dateGenerated: config?.manifest?.dataGenerated,
        status: status,
        hotfix: patchValue > 0,
        codeResult: config?.manifest?.code,
        configuration: config,
        references: config?.manifest?.references,
        havePermission: ((this.instance?.dataZone === DataZone.DEVELOPMENT && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII]) || (this.instance?.dataZone === DataZone.SECURE && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII]) || (this.instance?.dataZone === DataZone.LIVE && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE])),
        disableSelection : (this.inProgress || this.isVerifying || this.disableSelect) || ((this.instance?.dataZone === DataZone.DEVELOPMENT && !this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII])
        || (this.instance?.dataZone === DataZone.SECURE && !this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII])
        || (this.instance?.dataZone === DataZone.LIVE && !this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE])),
        disableApply: disableAction,
        showApply: !this.inProgress && ((!config.status && !config.skipTest) || config.status === ConfigurationApplicationStatus.VERIFIED) && !deployStatus,
        showApplyLock: !this.inProgress && ((!config.status && !config.skipTest) || config.status === ConfigurationApplicationStatus.VERIFIED),
        disableRetry: disableAction,
        showRetry: !this.inProgress && (config.status === ConfigurationApplicationStatus.TEST_FAILED || config.status === ConfigurationApplicationStatus.CONFIGURE_FAILED) && !deployStatus,
        showRetryLock: config.status === ConfigurationApplicationStatus.TEST_FAILED || config.status === ConfigurationApplicationStatus.CONFIGURE_FAILED
      };
    });
   
  }
    /**
   * Calls filter function when search term changes for components
   * @param - the search term entered
   */
  searchedItems(result): void {
    this.searchedResult = result;
    this.changeDetectorRef.detectChanges();
  }
  // updating the selected package - page refresh / config updation
  updateSelectedPack(){
    const selectedPack = this.configurations?.find(config => config.id === this.instance?.latestConfigurationState?.configurationId);
    if (selectedPack && selectedPack.skipTest) {
      this.selectedId = selectedPack?.id;
      this.selection = selectedPack;
    } else {
      this.selectedId = undefined;
      this.selection = undefined;
    }
  }
}
